<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-select ttRememberId="w_cuttingplans.cuttingplanstatus_no"
                       ttLabel="cuttingplanstatus_no"
                       [(ttModel)]="setting.cuttingplanstatus_no"
                       (ttModelChange)="onChanged($event, 'cuttingplanstatus_no')"
                       [ttData]="selectListStatuses"
                       ttDataId="item_id"
                       ttDataName="item_name"
                       ttShowClearButton></tt-select>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-select ttLabel="operation" [(ttModel)]="setting.operation_id" (ttModelChange)="onChanged($event, 'operation_id')" [ttData]="selectListOperations" ttDataId="operation_id" ttDataName="operation_name"></tt-select>
        </tt-card>
    </div>

    <tt-card class="col-xs-12 col-md-12 p-5">
        <tt-tabs ttRememberId="w_cuttingplans.bg_cuttingplans_main" [(ttSelectedId)]="setting.bg_cuttingplans_main" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="CUTTINGPLANS" ttLabel="bg_cuttingplans_main_cuttingplans"></tt-tab>
            <tt-tab ttId="POPOWS" ttLabel="bg_cuttingplans_main_popows"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-grid [hidden]="setting.bg_cuttingplans_main !== 'CUTTINGPLANS'" *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
    <tt-grid [hidden]="setting.bg_cuttingplans_main !== 'POPOWS'" *ngIf="!!gridPows" class="p-5 flex-1" [(ttOptions)]="gridPows"></tt-grid>
</tt-page>
